<template>
  <div class="benefits-list">
    <div
      v-for="(benefit, index) in benefits"
      :key="index"
      class="benefits-list__item"
    >
      <div class="benefits-list__icon-container">
        <gl-icon
          :gray="benefit.iconType === 'gray'"
          :height="16"
          :name="benefit.icon || 'I-Check'"
          :warning="benefit.iconType === 'warning'"
          :width="16"
        />
      </div>
      <div class="benefits-list__text">
        <span
          v-if="benefit.isHtml"
          v-html="benefit.label"
        />
        <span v-else>
          {{ benefit.label }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import GlIcon from '@/components/gl-icon.vue';

export default {
  name: 'PlanBenefitsList',
  components: {
    GlIcon
  },
  props: {
    benefits: {
      type: Array,
      required: true,
      default: () => []
    }
  }
};
</script>

<style scoped>
.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.benefits-list__item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.benefits-list__icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.benefits-list__text {
  font-size: 14px;
  font-weight: 500;
  color: #091540;
}

.benefits-list__text ::v-deep .value-highlight {
  font-weight: 700;
}
</style>
